// Shared parcel-category list — single source of truth for both the
// passenger self-service page and the office walk-in registration page.
// `passengerVisible` controls which categories show in the ticket-linked
// passenger flow (exactly 5, per the confirmed business rule); every value,
// visible or not, stays a valid parcelType everywhere else (DB, office
// walk-in flow, historical records) — hiding is UI-only, nothing is deleted.
export const PARCEL_TYPES = [
  { key: 'food', label: 'مواد غذائية', icon: '🍚', passengerVisible: true },
  { key: 'clothes', label: 'ملابس', icon: '👕', passengerVisible: true },
  { key: 'personal_items', label: 'أغراض شخصية', icon: '🎒', passengerVisible: true },
  { key: 'electronics', label: 'إلكترونيات', icon: '💻', passengerVisible: true },
  { key: 'general_goods', label: 'بضائع عامة', icon: '📦', passengerVisible: true },
  { key: 'documents', label: 'مستندات', icon: '📄', passengerVisible: false },
  { key: 'medicines', label: 'أدوية', icon: '💊', passengerVisible: false },
  { key: 'fragile', label: 'قابل للكسر', icon: '🍷', passengerVisible: false },
  { key: 'corporate', label: 'طرود شركات', icon: '🏢', passengerVisible: false },
  { key: 'express', label: 'سريع', icon: '⚡', passengerVisible: false },
];
